<template>
  <div class="stub">
    <SkeletAvatar class="stub__avt" :size="24"/>
    <div class="stub__hdr">
      <SkeletItem style="width: 24px" :radius="6" :height="18" />
      <SkeletItem style="width: 42px" :radius="6" :height="18" />
      <SkeletItem style="width: 46px" :radius="6" :height="18" />
      <SkeletItem style="width: 18px" :radius="6" :height="18" />
      <SkeletItem style="width: 18px" :radius="6" :height="18" />
    </div>
    <div class="stub__ftr">
      <SkeletItem style="width: 18px" :radius="6" :height="18" />
      <SkeletItem style="width: 74px" :radius="6" :height="18" />
      <SkeletItem style="width: 86px" :radius="6" :height="18" />
    </div>
  </div>
</template>

<script setup>
  import { SkeletAvatar, SkeletItem } from '@/Groups/CoinTooltip/private/imports/externalTemplates';
</script>

<style lang="scss" scoped>
  @import "./styles.scss";
</style>